// Library Imports
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Local Imports 
import { useIsAuthenticatedUser } from '@/utils';
import { getRoleHomePath } from '@/router/roles';

const PublicRoutes = () => {
    const isAuthenticated = useIsAuthenticatedUser();
    const currentUser = useSelector(state => state?.currentUser?.currentUser);
    const isNewUser = currentUser?.isNewUser;

    if (isNewUser || isAuthenticated) {
        return <Navigate to={getRoleHomePath(currentUser)} replace />;
    }

    return (
        <Suspense>
            <Outlet />
        </Suspense>
    );
};

export default PublicRoutes;
